import { render, staticRenderFns } from "./IbToolTip.vue?vue&type=template&id=264720f0&scoped=true"
import script from "./IbToolTip.vue?vue&type=script&lang=js"
export * from "./IbToolTip.vue?vue&type=script&lang=js"
import style0 from "./IbToolTip.vue?vue&type=style&index=0&id=264720f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264720f0",
  null
  
)

export default component.exports